exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".z-cascader .el-cascader-node[data-v-5a460a15]{height:auto;line-height:16px;padding:8px 30px 8px 20px}.z-cascader .el-checkbox[data-v-5a460a15]{pointer-events:none}.z-cascader .z-cascader-event[data-v-5a460a15]{width:100%;height:20px;position:absolute;left:0;top:50%;transform:translateY(-50%)}.z-cascader .z-cascader-label[data-v-5a460a15]{flex:1;display:inline-block;width:100%;max-width:200px;white-space:pre-wrap;word-break:break-all}\n", ""]);

// exports
